import { CSSProperties, FC } from 'react';
import TopNavigation, {
  TopNavigationProps,
} from '@amzn/awsui-components-core/top-navigation';
import {
  DEFAULT_LOCALE,
  HEADER_MESSAGE_BUNDLE,
  IS_BEHIND_MONS,
  MONS_ROUTE_BASE,
} from 'src/constants';
import { useTranslate } from 'src/hooks/useTranslate';

// Identity link is a native <a>, so the MONS base path must be added manually.
const HOME_HREF = `${IS_BEHIND_MONS ? MONS_ROUTE_BASE : ''}`;

// z-index per Cloudscape top-navigation guidance (1002–1999).
export const STICKY_HEADER_STYLE: CSSProperties = {
  position: 'sticky',
  top: 0,
  zIndex: 1002,
};

// Must match the wrapper id set in AppLayout/AppLayoutWithNav.
export const HEADER_WRAPPER_ID = 'app-header';

const HEADER_BACKGROUND_COLOR = '#2b3747';

// Don't tag-qualify the selector: the visible bar is a <header>, with a hidden
// virtual <div> copy. !important wins since Cloudscape's rule has neither.
const HEADER_BACKGROUND_CSS = `
  #${HEADER_WRAPPER_ID} [class*="awsui_top-navigation_"] {
    background: ${HEADER_BACKGROUND_COLOR} !important;
  }
`;

const Header: FC = () => {
  const { translate } = useTranslate(HEADER_MESSAGE_BUNDLE);

  // Single locale today; extend items[] as more .puff.json files are added.
  const localeUtility: TopNavigationProps.MenuDropdownUtility = {
    type: 'menu-dropdown',
    text: translate('language_en_us'),
    ariaLabel: translate('language_label'),
    iconName: 'globe',
    items: [
      {
        id: DEFAULT_LOCALE,
        text: translate('language_en_us'),
      },
    ],
  };

  const appTitle = translate('app_title');

  return (
    <>
      <style>{HEADER_BACKGROUND_CSS}</style>
      <TopNavigation
        identity={{
          href: HOME_HREF,
          title: appTitle,
        }}
        utilities={[localeUtility]}
      />
    </>
  );
};

export default Header;
